import { Table, Button } from "antd";
import React, { FC, useMemo } from "react";
import { ApplicantsColumns, IApplicant, IJob, IProjectDetails } from "../helper";
import { useNavigate } from "react-router-dom";
import queryString from "query-string";
import { ROUTES } from "../../../Components/common";

interface ApplicantsListProps {
  applicants: IApplicant[];
  project?: IProjectDetails;
  projectId?: string;
  jobId?: string;
  openRemarks: (jobApplicationId: string) => void;
  remarksUnreadCounts?: { [jobApplicationId: string]: number };
  sendEmailRequest: (_id: string, emailBody: string, subject: string) => Promise<void>;
  openMoreInfo: (applicant: IApplicant) => void;
  openProfileDrawer: (applicant: IApplicant) => void;
  refetch: () => void;
  openTalentPool: (applicant: IApplicant) => void;
  setOfferModal: (modal: { visible: boolean; applicationId?: string }) => void;
  markAsHired: (applicationId: string) => void;
  openOfferModal: (record: IApplicant) => void;
  setViewOfferModal: (modal: { visible: boolean; applicationId?: string }) => void;
  openRecruiterReject?: (applicationId: string) => void;
  readFeedbackIds?: Set<string>;
  openSendRejection?: (record: IApplicant) => void;
}

const ApplicantsList: FC<ApplicantsListProps> = ({
  applicants,
  openRemarks,
  remarksUnreadCounts,
  sendEmailRequest,
  openMoreInfo,
  refetch,
  jobId,
  project,
  openTalentPool,
  setOfferModal,
  markAsHired,
  openOfferModal,
  setViewOfferModal,
  openRecruiterReject,
  readFeedbackIds,
  openSendRejection,
}) => {
  const navigate = useNavigate();

  const dataSource = useMemo(
    () => applicants.map((e) => ({ ...e, key: e._id })),
    [applicants]
  );

  const scheduleCall = (applicant: IApplicant) => {
    const query = queryString.stringify({
      applicantId: applicant.applicantId,
      jobId: jobId,
      jobApplicationId: applicant.jobApplicationId || "",
    });
    navigate(`${ROUTES.AVAILABILITY}?${query}`);
  };

  return (
    <Table
      dataSource={dataSource}
      columns={(ApplicantsColumns(
        openRemarks,
        scheduleCall,
        sendEmailRequest,
        openRemarks,
        project as IProjectDetails,
        openMoreInfo,
        openTalentPool,
        refetch,
        setOfferModal,
        markAsHired,
        openOfferModal,
        setViewOfferModal,
        openRecruiterReject,
        readFeedbackIds,
        openSendRejection,
        remarksUnreadCounts,
      ) || []).map(col => ({
        ...col,
        title: typeof col.title === 'string' ? 
          <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{col.title}</span> : 
          col.title,
        render: col.render ? (text: any, record: IApplicant, index: number) => {
          const rendered = col.render!(text, record, index);
          if (React.isValidElement(rendered)) {
            return React.cloneElement(rendered as React.ReactElement<any>, {
              style: { ...(rendered as React.ReactElement<any>).props.style, fontSize: '16px' }
            });
          }
          return <span style={{ fontSize: '16px' }}>{String(rendered)}</span>;
        } : (text: any) => <span style={{ fontSize: '16px' }}>{text}</span>
      }))}
      rowKey="_id"
      pagination={false}
      components={{
        body: {
          cell: (props: any) => (
            <td {...props} style={{ ...props.style, fontSize: '16px' }} />
          ),
        },
      }}
    />
  );
};

export default ApplicantsList;